import axios from "axios";

import { basePath, createHeaders } from "./utils";

/**
 * GET
 * /api/charge/units
 * 
 * Returns all charging units for current org
 */
export const getChargingUnits = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/units`, config)
      .then((resp) => {
        console.log("getChargingUnits", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/units/{unitId: string($uuid)}
 * 
 * Returns all charging units for unit id
 */
export const getChargingUnitsByUnitId = (unitId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/units/${unitId}`, config)
      .then((resp) => {
        console.log("getChargingUnitsByUnitId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      })
  });
};

/**
 * GET
 * /api/charge/units/station/{stationId: string($uuid)}
 * 
 * Returns all charging units for a station
 */
export const getChargingUnitsByStationId = (stationId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/units/station/${stationId}`, config)
      .then((resp) => {
        console.log("getChargingUnitsByStationId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/unit/types
 * 
 * Returns all charge unit types
 */
export const getChargingUnitTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/unit/types`, config)
      .then((resp) => {
        console.log("getChargingUnitTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/unit/status/types
 * 
 * Returns all charge unit status types
 */
export const getChargingUnitStatusTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/unit/status/types`, config)
      .then((resp) => {
        console.log("getChargingUnitStatusTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/stations
 * 
 * Returns all charging stations for current organization
 */
export const getChargingStations = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/stations`, config)
      .then((resp) => {
        console.log("getChargingStations", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/stations/full
 * 
 * Returns all charging stations with all info for current organization
 */
export const getChargingStationsFull = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/stations/full`, config)
      .then((resp) => {
        console.log("getChargingStationsFull", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/station/{stationId: string($uuid)}
 * 
 * Returns charge station for station id
 */
export const getChargingStationByStationId = (stationId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/station/${stationId}`, config)
      .then((resp) => {
        console.log("getChargingStationByStationId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/station/{stationId: string($uuid)}/internet
 * 
 * Returns all internet connections configured for a station
 */
export const getChargingStationInternetConnections = (stationId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/station/${stationId}/internet`, config)
      .then((resp) => {
        console.log("getChargingStationInternetConnections", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/station/{stationId: string{$uuid}}/full
 * 
 * Returns charge station for station id with all details
 */
export const getChargingStationFullByStationId = (stationId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/station/${stationId}/full`, config)
      .then((resp) => {
        console.log("getChargingStationFullByStationId", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  })
};

/**
 * GET
 * /api/charge/station/{stationId: string($uuid)}/commprotocol
 * 
 * Returns all internet connections configured for a station
 * 
 * (above should read "all comm protocols" or something similar)
 */
export const getChargingStationCommProtocols = (stationId) => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/station/${stationId}/commprotocol`, config)
      .then((resp) => {
        console.log("getChargingStationCommProtocols", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/station/infra/types
 * 
 * Returns all station infrastructure types
 */
export const getStationInfrastructureTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/station/infra/types`, config)
      .then((resp) => {
        console.log("getStationInfrastructureTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/ports
 * 
 * Returns all charging ports for current organization
 */
export const getChargingPorts = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/ports`, config)
      .then((resp) => {
        console.log("getChargingPorts", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/port/status/types
 * 
 * Returns all charge port status types
 */
export const getChargingPortStatusTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/port/status/types`, config)
      .then((resp) => {
        console.log("getChargingPortStatusTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/manufacturer
 * 
 * Returns all charging equipment manufacturers
 */
export const getChargingEquipmentManufacturers = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/manufacturer`, config)
      .then((resp) => {
        console.log("getChargingEquipmentManufacturers", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/manufacturer/types
 * 
 * Returns all manufacturer types
 */
export const getManufacturerTypes = () => {
  const config = {};
  config.header = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/manufacturer/types`, config)
      .then((resp) => {
        console.log("getManufacturerTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/manufacturer/model
 * 
 * Returns all charging manufacturer models
 */
export const getChargingManufacturerModels = () => {
  const config = {};
  config.header = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/manufacturer/model`, config)
      .then((resp) => {
        console.log("getChargingManufacturerModels", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/location/types
 * 
 * Returns all location types
 */
export const getLocationTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/location/types`, config)
      .then((resp) => {
        console.log("getLocationTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/location/status/types
 * 
 * Returns all location status types
 */
export const getLocationStatusTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/location/status/types`, config)
      .then((resp) => {
        console.log("getLocationStatusTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/internet/types
 * 
 * Returns all internet connection types
 */
export const getInternetConnectionTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/internet/types`, config)
      .then((resp) => {
        console.log("getInternetConnectionTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      })
  });
};

/**
 * GET
 * /api/charge/infra/attribute/types
 * 
 * Returns all infrastructure attribute types
 */
export const getInfrastructureAttributeTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/infra/attribute/types`, config)
      .then((resp) => {
        console.log("getInfrastructureAttributeTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/equipment
 * 
 * Returns all charging equipment information for current org
 */
export const getChargingEquipmentInfo = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/equipment`, config)
      .then((resp) => {
        console.log("getChargingEquipmentInfo", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/equipment/types
 * 
 * Returns all equipment types
 */
export const getEquipmentTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/equipment/types`, config)
      .then((resp) => {
        console.log("getEquipmentTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/equipment/status/types
 * 
 * Returns all equipment (charge unit, station) status types
 */
export const getEquipmentStatusTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/equipment/status/types`, config)
      .then((resp) => {
        console.log("getEquipmentStatusTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/connectors
 * 
 * Returns all charging connectors for current org
 */
export const getChargingConnectors = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/connectors`, config)
      .then((resp) => {
        console.log("getChargingConnectors", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/connector/types
 * 
 * Returns all connector types
 */
export const getChargingConnectorTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/connector/types`, config)
      .then((resp) => {
        console.log("getChargingConnectorTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/connector/status/types
 * 
 * Returns all connector status types
 */
export const getChargingConnectorStatusTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/connector/status/types`, config)
      .then((resp) => {
        console.log("getChargingConnectorStatusTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/commprotocol/types
 * 
 * Returns all comm protocol types
 */
export const getCommProtocolTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/commprotocol/types`, config)
      .then((resp) => {
        console.log("getCommProtocolTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/accessdetail/types
 * 
 * Returns all access detail code types
 */
export const getAccessDetailCodeTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/accessdetail/types`, config)
      .then((resp) => {
        console.log("getAccessDetailCodeTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};

/**
 * GET
 * /api/charge/access/types
 * 
 * Returns all access types
 */
export const getAccessTypes = () => {
  const config = {};
  config.headers = createHeaders();

  return new Promise((resolve, reject) => {
    axios
      .get(`${basePath}/charge/access/types`, config)
      .then((resp) => {
        console.log("getAccessTypes", resp);
        resolve(resp.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err);
      });
  });
};
